import React, { useCallback, useState, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ReportCurrency, ClientCustomCalendarModel } from '../../../models';
import * as Styled from './styled';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { buildDropdownList } from './helpers/buildReportSettingData';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingMaturityProps {
  onChange: (updatedValue: ReportSettingMaturityState) => void;
  reportSettingState: ReportSettingMaturityState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT?: boolean;
}

export interface ReportSettingMaturityState {
  selectedCurrency: SelectOption<ReportCurrency>;
  shortStartDate: string;
  shortEndDate: string;
  selectedRunBy: SelectOption<string>;
  selectedRunWith: SelectOption<string>;
  selectedEndDateOption: string;
  isValid: boolean;
}

function ReportSettingMaturity({
  onChange,
  reportSettingState,
  reportTypeSetting,
}: ReportSettingMaturityProps): JSX.Element {
  const runByList = buildDropdownList('Maturity', 'RunBy', reportTypeSetting);
  const runWithList = buildDropdownList(
    'Maturity',
    'RunWith',
    reportTypeSetting,
  );
  const [isDateRangeValid, setDateRangeValidStatus] = useState(false);
  const inputHandler = useCallback(
    ({ isValid, ...rest }: ReportSettingMaturityState) => {
      let isValidInput = isDateRangeValid;
      if (isValid !== undefined) {
        isValidInput = isValid;
        setDateRangeValidStatus(isValid);
      }

      onChange({
        ...rest,
        isValid: isValidInput,
      });
    },
    [onChange, isDateRangeValid],
  );
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                inputHandler({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [inputHandler, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
      <Styled.DropdownBar>
        <div>
          <Icon name="gear" />
        </div>
        <div>
          <Select
            label="Run By"
            name="RunBy"
            options={runByList}
            onChange={useCallback(
              (option: SelectOption<string>): void => {
                inputHandler({
                  ...reportSettingState,
                  selectedRunBy: option,
                });
              },
              [inputHandler, reportSettingState],
            )}
            value={reportSettingState.selectedRunBy}
          />
          <p />
          <Select
            label="Run With"
            name="RunWith"
            options={runWithList}
            onChange={useCallback(
              (option: SelectOption<string>): void => {
                inputHandler({
                  ...reportSettingState,
                  selectedRunWith: option,
                });
              },
              [inputHandler, reportSettingState],
            )}
            value={reportSettingState.selectedRunWith}
          />
        </div>
      </Styled.DropdownBar>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingMaturity);
